export class IconoUtility{


    public static getNameIconoType(filename : string) : string{

        let _icono = '';
        let _extension = filename.substring(filename.lastIndexOf('.'), filename.length);
        _extension = _extension.toLowerCase();

        if(_extension === '.jpg' || _extension === '.jpeg' || _extension === '.png' || _extension === '.bmp'){
            _icono = "imagen";
        } else if(_extension === '.pdf'){
            _icono = 'pdf';
        } else if(_extension === '.doc' || _extension === '.docx'){
            _icono = 'word';
        } else if(_extension === '.xls' || _extension === '.xlsx' || _extension === '.xlsm'){
            _icono = 'excel';
        } else if(_extension === '.txt'){
            _icono = 'txt';
        } else if(_extension === '.zip'){
            _icono = 'zip';
        } else if(_extension === 'rar'){
            _icono = 'rar';
        } else{
            _icono = 'file';
        }
        return _icono;        
    }

}


// WEBPACK FOOTER //
// /app/src/app/shared/utilities/icono.utility.ts